import { render } from "./Store.vue?vue&type=template&id=2a70fbf8&scoped=true"
import script from "./Store.vue?vue&type=script&lang=js"
export * from "./Store.vue?vue&type=script&lang=js"

import "./Store.vue?vue&type=style&index=0&id=2a70fbf8&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/JBN/mi-stock-jbn-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a70fbf8"]])

export default __exports__